import React, { useState } from 'react';
import { Text } from '@soluto-design/react';
import Link, { LinkProps } from '@soluto-design/link';
import AccordionViewMore from '../../molecules/AccordionViewMore';
import cls from '@soluto-design/styles/cls';

export interface BlockGlossaryBaseProps {
    letter: string;
    items: LinkProps[];
}

export interface BlockGlossaryProps extends BlockGlossaryBaseProps {
    showMoreLabel?: string;
    className?: string;
    topHeight: number;
}

export default function BlockGlossary({
    letter,
    items,
    showMoreLabel,
    className,
    topHeight,
}: BlockGlossaryProps) {
    const [showAll, setShowAll] = useState(false);

    const limit = 12;

    const displayedItems = showAll ? items : items.slice(0, limit);

    const handleShowMore = () => {
        setShowAll(true);
    };

    const showButton = items?.length > limit && !showAll && showMoreLabel;

    return (
        <div className={cls('relative', className)}>
            <span
                data-letter-id={letter}
                id={letter === '#' ? 'others' : letter}
                className="absolute"
                style={{
                    top: `calc((${topHeight}px + var(--soluto-spacing-xl))*-1)`,
                }}
            />
            {letter && (
                <Text
                    component="p"
                    className="text-h300 text-text-primary pb-32 uppercase">
                    {letter}
                </Text>
            )}
            <div className="flex flex-col gap-y-16 lg:flex-row lg:flex-wrap xl:row">
                {displayedItems?.length > 0 &&
                    displayedItems.map((item, i) => {
                        return (
                            <Link
                                key={item.children}
                                {...item}
                                className="block text-b400 !no-underline !font-regular lg:w-[33%] lg:grow xl:col-span-4">
                                <span itemProp="name">{item.children}</span>
                            </Link>
                        );
                    })}
            </div>
            {showButton && (
                <div className="pt-32">
                    <AccordionViewMore
                        label={showMoreLabel}
                        onClick={handleShowMore}
                    />
                </div>
            )}
        </div>
    );
}
